module.exports = __webpack_public_path__ + "static/fonts/PorscheNextWCy-Thin.8804fc3.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/PorscheNextWCy-Thin.woff
// module id = 7inH
// module chunks = 5